import { create } from 'zustand';

export const useAssetCategoryStore = create((set) => ({
    // Data State
    items: [],
    loading: false,
    error: null,
    success: null,

    // UI State
    isFormOpen: false,
    isDetailsOpen: false,
    selectedItem: null,

    // Pagination & Filtering
    pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false
    },
    sorting: {
        sortBy: 'createdAt',
        sortDirection: 'desc'
    },
    search: '',
    columnFilters: {},
    uniqueValues: {},
    dropdownData: {
        assetGroups: [],
        owners: [],
        categories: [],
        securityValues: []
    },

    // Actions
    setData: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setSuccess: (success) => set({ success }),
    setDropdownData: (dropdownData) => set({ dropdownData }),

    setPagination: (pagination) => set((state) => ({
        pagination: { ...state.pagination, ...pagination }
    })),

    setUniqueValues: (uniqueValues) => set({ uniqueValues }),

    setSorting: (sorting) => set((state) => ({
        sorting: { ...state.sorting, ...sorting }
    })),

    setSearch: (search) => set({ search }),

    setColumnFilters: (filters) => set({ columnFilters: filters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues }),

    // Form Helpers
    openForm: (item = null) => set({ isFormOpen: true, selectedItem: item }),
    closeForm: () => set({ isFormOpen: false, selectedItem: null }),

    // Details Helpers
    openDetailsDialog: (item) => set({ isDetailsOpen: true, selectedItem: item }),
    closeDetailsDialog: () => set({ isDetailsOpen: false, selectedItem: null }),

    // Clearers
    clearError: () => set({ error: null }),
    clearSuccess: () => set({ success: null }),
    reset: () => set({
        items: [],
        loading: false,
        error: null,
        success: null,
        isFormOpen: false,
        isDetailsOpen: false,
        selectedItem: null,
        search: '',
        columnFilters: {},
        uniqueValues: {},
        pagination: {
            currentPage: 1,
            itemsPerPage: 10,
            totalItems: 0,
            totalPages: 0,
            hasNextPage: false,
            hasPreviousPage: false
        }
    })
}));
